<template>
  <v-card class="reporteAuditoria">
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.commons.filters.title") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-expand-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
        <v-layout row wrap>
          <v-flex md12>
            <filters ref="filters" @filter="filter" @report="report" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="rev"
              class="reporteAuditoria dataTable"
              sort-by="rev"
              :sort-desc="true"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options">
              <template #top>
                <v-text-field v-model.trim="search" dense hide-details :label="$t('view.commons.search')" append-icon="mdi-magnify" />
              </template>
              <template #item.fecha="{ item }">
                {{ formatDateTime(item.fecha) }}
              </template>
              <template #item.accion="{ item }">
                <buttonCustom
                  :ref="`dataTableBtnAuditDetail_${item.clave}`"
                  :paramtype="'Object'"
                  :paramobj="item"
                  action="audit"
                  icon="fas fa-search"
                  :title="$t('view.commons.audit')"
                  @audit="audit" />
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-expand-transition>
  </v-card>
</template>

<script>
import ReporteAuditoriaAPI from "@/services/bitacoras/auditoria"; /** *******************************/
import Filters from "@/views/bitacoras/reporteAuditoria/Filters"; /** *******************************/
import ButtonCustom from "@/components/datatable/ButtonCustom"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import { formatDateTime } from "@/helpers/date-methods";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

export default {
  name: "ReporteAuditoriaTable"
  , components: { Filters, ButtonCustom }
  , data() {
    return {
      options: {}
      , filtros: null
      , search: ""
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.bitacoras.reporteAuditoria.form.modulo.th"), align: "center", sortable: true, class: "modulo", value: "modulo" }
              , { text: this.$t("view.bitacoras.reporteAuditoria.form.revision.th"), align: "center", sortable: true, class: "rev", value: "rev" }
              , { text: this.$t("view.bitacoras.reporteAuditoria.form.usuario.th"), align: "center", sortable: true, class: "usuario", value: "usuario" }
              , { text: this.$t("view.bitacoras.reporteAuditoria.form.fecha.th"), align: "center", sortable: true, class: "fecha", value: "fecha" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;
      this.$refs.filters.loading(true);

      const serverSideDataT = this.prepareData();
      const response = await ReporteAuditoriaAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
      this.$refs.filters.loading(false);
    }
    , async report(filters) {
      if (this.view.elem.datatable.total <= 0) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.minregs"));
        return false;
      }

      if (this.view.elem.datatable.total > 50000) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.maxregs"));
        return false;
      }

      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.filtros = fls;

      this.$refs.filters.loading(true);

      try {
        const serverSideDataT = this.prepareData();
        const response = await ReporteAuditoriaAPI.report(serverSideDataT);
        if (response && response.data.size > 0) {
          const url = globalThis.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", response.headers.filename.replaceAll("\"", "")); // or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("view.commons.errrep"));
        }
      } catch (error) {
        console.error(error);
      }

      this.$refs.filters.loading(false);
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.filtros = fls;
      this.options.page = 1;
      this.load();
    }
    , async audit(item) {
      const { clave, tabla, modulo, rev } = item;
      this.$emit("auditRow", clave, tabla, modulo, rev);
    }
    , formatDateTime
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bitacoras/reporteAuditoria/DataTable.vue